import './corporate-fi-verification.scss';

import { KYB_ACCOUNT_TYPE } from '@config';
import { useCorporateFIStore } from '@stores/onboarding';
import React from 'react';

import { CORP_STEPS_DNFI } from '../corporate-non-fi/corporate-non-fi-constants';
import { CorporateVerificationBase } from '../corporate-verification-base';

const CorporateFIVerification = () => (
  <CorporateVerificationBase
    className="corp-fi-verification"
    useStore={useCorporateFIStore}
    steps={CORP_STEPS_DNFI}
    kybAccountType={KYB_ACCOUNT_TYPE.CORPORATE_FI}
  />
);

export { CorporateFIVerification };
